<template>
  <Transition name="fade">
    <div v-if="visible" :class="['toast', type]">{{ message }}</div>
  </Transition>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'Toast',
  setup() {
    const visible = ref(false)
    const message = ref('')
    const type = ref('success')
    let timer = null

    function show(msg, t = 'success') {
      message.value = msg
      type.value = t
      visible.value = true
      clearTimeout(timer)
      timer = setTimeout(() => {
        visible.value = false
      }, 3200)
    }

    return { visible, message, type, show }
  },
}
</script>

<style scoped>
.toast {
  position: fixed;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  padding: 0.85rem 1.5rem;
  border-radius: var(--radius-sm);
  font-weight: 500;
  font-size: 0.95rem;
  z-index: 2000;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.toast.success {
  background: var(--color-success);
  color: #fff;
}

.toast.error {
  background: var(--color-error);
  color: #fff;
}
</style>
